"use strict";

var _classCallCheck = require("/Users/chengluyu/Developer/anichart-marker/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/chengluyu/Developer/anichart-marker/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
}); // Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.

var common_1 = require("../common");
/** A ObjectClass contains the runtime info for a chart object */


var ObjectClass =
/*#__PURE__*/
function () {
  function ObjectClass(parent, object, state) {
    _classCallCheck(this, ObjectClass);

    this.parent = parent;
    this.object = object;
    this.state = state;
  }
  /** Initialize the state of the object */


  _createClass(ObjectClass, [{
    key: "initializeState",
    value: function initializeState() {}
    /** Get the UI spec for property panel */

  }, {
    key: "getAttributePanelWidgets",
    value: function getAttributePanelWidgets(manager) {
      return [manager.text("No editable attribute")];
    }
  }, {
    key: "getTemplateParameters",
    value: function getTemplateParameters() {
      return null;
    }
    /** Create a default object */

  }], [{
    key: "createDefault",
    value: function createDefault() {
      var id = common_1.uniqueID();
      var obj = {
        _id: id,
        classID: this.classID,
        properties: {},
        mappings: {}
      };
      obj.properties = common_1.deepClone(this.defaultProperties);

      for (var attr in this.defaultMappingValues) {
        if (this.defaultMappingValues.hasOwnProperty(attr)) {
          var value = common_1.deepClone(this.defaultMappingValues[attr]);
          obj.mappings[attr] = {
            type: "value",
            value: value
          };
        }
      }

      return obj;
    }
  }]);

  return ObjectClass;
}();
/** The static classID */


ObjectClass.classID = "object";
/** The static type */

ObjectClass.type = null;
/** The metadata associated with the class */

ObjectClass.metadata = {};
/** Default attributes */

ObjectClass.defaultProperties = {};
/** Default mapping values */

ObjectClass.defaultMappingValues = {};
exports.ObjectClass = ObjectClass;
/** Store the registered object classes */

var ObjectClasses =
/*#__PURE__*/
function () {
  function ObjectClasses() {
    _classCallCheck(this, ObjectClasses);
  }

  _createClass(ObjectClasses, null, [{
    key: "Create",

    /** Create a ObjectClass for a object and its state */
    value: function Create(parent, object, state) {
      var constructor = ObjectClasses.registeredObjectClasses.get(object.classID);

      if (!constructor) {
        throw new Error("undefined object class '".concat(object.classID, "'"));
      }

      return new constructor(parent, object, state);
    }
  }, {
    key: "CreateDefault",
    value: function CreateDefault(classID) {
      var constructor = ObjectClasses.registeredObjectClasses.get(classID);

      for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      var obj = constructor.createDefault.apply(constructor, args);
      return obj;
    }
  }, {
    key: "GetMetadata",
    value: function GetMetadata(classID) {
      var constructor = ObjectClasses.registeredObjectClasses.get(classID);

      if (constructor) {
        return constructor.metadata || null;
      } else {
        return null;
      }
    }
  }, {
    key: "Register",
    value: function Register(constructor) {
      ObjectClasses.registeredObjectClasses.set(constructor.classID, constructor);

      if (constructor.type != null) {
        ObjectClasses.RegisterType(constructor.classID, constructor.type);
      }
    }
  }, {
    key: "RegisterType",
    value: function RegisterType(name) {
      for (var _len2 = arguments.length, parents = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
        parents[_key2 - 1] = arguments[_key2];
      }

      ObjectClasses.type2Parents.set(name, parents);
    }
  }, {
    key: "isType",
    value: function isType(type, parentType) {
      if (type == parentType) {
        return true;
      }

      var parents = ObjectClasses.type2Parents.get(type);

      if (parents != null) {
        return parents.some(function (t) {
          return ObjectClasses.isType(t, parentType);
        });
      } else {
        return false;
      }
    }
    /**
     * Gets an interator of registered classes.
     */

  }, {
    key: "RegisteredClasses",
    value: function RegisteredClasses() {
      return this.registeredObjectClasses.values();
    }
  }]);

  return ObjectClasses;
}();

ObjectClasses.registeredObjectClasses = new Map();
ObjectClasses.type2Parents = new Map();
exports.ObjectClasses = ObjectClasses;
exports.isType = ObjectClasses.isType;